/** @format */

import axios from "axios"
import config from "../../../config/config"
// import { useDispatch } from "react-redux"

// export const SUCCES = "SUCCES"

// const dispatch = useDispatch()
export const TOKEN = "TOKEN"

const LOGIN = config.baseUrl + "owner/loginOwner/"
const VERIFY_LOGIN = config.baseUrl + "owner/verifyLogin/"

export const contractLogin = (data) => {
  console.log("kkkkkkk")
  axios
    .post(LOGIN, data)
    .then((res) => console.log(res))
    .catch((err) => console.log(err))
}

export const getOwnerToken = (data) => {
  return {
    type: TOKEN,
    payload: data,
  }
}

// const trueVrify = () => {
//   return {
//     type: SUCCES,
//   }
// }

// export const verifyLoginAction = (data) => {
//   axios
//     .post(VERIFY_LOGIN, data)
//     .then((res) => {
//       res.data.status = "Success" ? props.stepOBJ.setTest(false) : "null"
//     })
//     .catch((err) => console.log(err))
// }

// {
//   res.data.status = "Success" ? dispatch(trueVrify) : null
// }
